import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const ADD_CUSTOM_POSITION_MUTATION = gql`
  mutation addCustomLine($documentVersion: DocumentVersionInput) {
    quotes {
      modify(documentVersion: $documentVersion) {
        addCustomLine {
          newLines {
            id
            ...CustomLinePricingFragment
          }
        }
      }
    }
  }
  ${CUSTOM_LINE_PRICING_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class AddCustomPositionMutation extends Mutation<RootMutation> {
  document = ADD_CUSTOM_POSITION_MUTATION;
}
